// @ts-nocheck
import ReactSVG from 'react-svg';
import React, { useContext } from 'react';
import { inject, observer } from 'mobx-react';
import { ThemeContext } from 'store/ThemeProvider';

import Column2 from './Column2';
import { IAllForColumnX } from './Common';
import ImageUtil from '../../utils/image';
import uColumn2List from './useColumn2List';
import RootStore from '../../store/RootStore';

interface IAllForColumn2 extends IAllForColumnX {
  isHot?: boolean;
  lazy?: boolean;
  rootStore?: RootStore;
  //  当前选中的index
  current: number;
}

// 注意， 我的相片也是用的这个组件哦
const AllForColumn2 = function (props: IAllForColumn2) {
  const { jigsaw, current } = props;
  const { column2, column1 } = uColumn2List(props.list);
  const { mainColor } = useContext(ThemeContext);

  const { galleryStore, wxuserStore } = props.rootStore!;
  const { currentPayedImages } = wxuserStore;

  return (
    <>
      {[column1, column2].map((column, index) => {
        return (
          <div
            className="rows"
            key={index}
            style={{
              borderRight: index === 0 ? `4px solid transparent` : 'none',
            }}
          >
            {column.map((one, index) => {
              const {
                id,
                width,
                height,
                hash,
                originalIndex,
                galleryid,
                show_mark,
              } = one;
              const isVertical = +height > +width;
              // const styleName = isVertical
              //   ? 'wx_375_crop_vertical'
              //   : 'wx_375_crop';
              const styleName = "wx_375_240";

              return (
                <Column2
                  lazy={props.lazy}
                  isVertical={isVertical}
                  key={id}
                  id={id}
                  width={width}
                  height={height}
                  jigsaw={jigsaw}
                  index={originalIndex}
                  src={ImageUtil.style(
                    hash,
                    styleName,
                    {
                      width: Number(width),
                      height: Number(height),
                      targetWidth: 375,
                      watermark: galleryStore.getWatermarksByKey(
                        String(galleryid),
                        show_mark
                      ),
                    },
                    id
                  )}
                  isPayed={currentPayedImages[String(id)]}
                  onClick={() => props.onClick({ id, index, galleryid })}
                  afterChild={
                    props.isHot &&
                    originalIndex < 10 && (
                      <div className="rank">
                        <ReactSVG
                          src={require('../../svg/icon-rank.svg')}
                          className={'rank-icon'}
                          style={{ color: mainColor }}
                        />
                        <span className={'number'}>NO.{originalIndex + 1}</span>
                      </div>
                    )
                  }
                />
              );
            })}
          </div>
        );
      })}
    </>
  );
};
export default inject('rootStore')(observer(AllForColumn2));
